import { NgModule } from '@angular/core';
import {LoginComponent} from '../login/login.component';
import {NonAuthUsersGuard} from '../../../resources/guards/nonAuthUsers.guard';
import {SignupComponent} from '../signup/signup.component';
import {RestoreComponent} from '../restore/restore.component';
import {RouterModule, Routes} from '@angular/router';

const routes: Routes = [

  {
    path: 'login',
    component: LoginComponent,
    data: {
      hidden: true
    },
    canActivate: [NonAuthUsersGuard]
  },
  // {
  //   path: 'signup',
  //   component: SignupComponent,
  //   data: {
  //     hidden: true
  //   },
  //   canActivate: [NonAuthUsersGuard]
  // },
  // {
  //   path: 'restore',
  //   component: RestoreComponent,
  //   data: {
  //     hidden: true
  //   },
  //   canActivate: [NonAuthUsersGuard]
  // },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: []
})
export class AuthRoutesModule { }

